import { useEffect, useRef } from 'react';

const usePrintCanvas = () => {
  const printFrame = useRef(null);

  // 初始化iframe
  useEffect(() => {
    const iframe = document.createElement('iframe');
    iframe.style.cssText = `
      position: absolute;
      width: 0;
      height: 0;
      border: none;
      visibility: hidden;
    `;
    document.body.appendChild(iframe);
    printFrame.current = iframe;
    return () => iframe.remove();
  }, []);

  const handlePrint = (canvasRef) => () => {
    try {
      const canvas = canvasRef.current;
      const imgData = canvas.toDataURL('image/png');
      const iframeDoc = printFrame.current.contentDocument;

      iframeDoc.open();
      iframeDoc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>二维码打印</title>
            <style>
              @page { margin: 0; }
              body { 
                margin: 1cm; 
                display: flex;
                justify-content: center;
              }
              img { 
                width: 100%; 
                max-width: 8cm;
                height: auto;
              }
            </style>
          </head>
          <body>
            <img src="${imgData}" alt="打印二维码" />
          </body>
        </html>
      `);
      iframeDoc.close();
      // 延迟确保资源加载
      setTimeout(() => {
        printFrame.current.contentWindow.focus();
        printFrame.current.contentWindow.print();
      }, 300);
    } catch (error) {
      console.log(error);
    }
  };

  return handlePrint;
};

export default usePrintCanvas;
